import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl102ValidationSchema = () => {
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardService: yup
      .string()
      .matches(/^\d+?$/, "Το πεδίο πρέπει να αποτελείται μόνο απο ψηφία")
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    keimeno: yup
      .string()
      .required(
        t(
          "Το πεδίο Κείμενο Παροχής Εξουσιοδοτήσεων και Δικαιωμάτων Υπογραφών είναι υποχρεωτικό."
        )
      ),
    fudocLoipa: yup.string(),
    commments: yup.string(),
    currentBoardMembers: yup.array().of(
      yup.object().shape({
        boardMemberFp1Name: yup
          .string()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1Surname: yup
          .string()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1Fathersname: yup
          .string()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1Idiot: yup
          .object()
          .shape({
            label: yup.string().required(),
            value: yup.number().required(),
          })
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1StartDate: yup
          .date()
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1EndDate: yup
          .date()
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1SoloRepresentative: yup
          .number()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        boardMemberFp1JointlyRepresentative: yup
          .number()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
      })
    ),
    deletedBoardMembers: yup.array().of(
      yup.object().shape({
        deletedBoardMemberFp1StartDate: yup.date(),
        deletedBoardMemberFp1EndDate: yup
          .date()
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
          .required(t("Το πεδίο είναι υποχρεωτικό")),
      })
    ),
    newBoardMembers: yup.array().of(
      yup.object().shape({
        fp1Name: yup.string().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1Surname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1Fathersname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1Idiot: yup.object().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1SoloRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1JointlyRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1StartDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
        fp1EndDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
        fp2Afm: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Name: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Surname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Fathersname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Doy: yup.object().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Adt: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema.max(20).required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Odos: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Arithm: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Tk: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Polh: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2Idiot: yup.object().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2SoloRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2JointlyRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2StartDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
        fp2EndDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
      })
    ),
    currentReprMembers: yup.array().of(
      yup.object().shape({
        reprFp1Name: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
        reprFp1Surname: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
        reprFp1Fathersname: yup
          .string()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        reprFp1StartDate: yup
          .date()
          .required(t("Το πεδίο είναι υποχρεωτικό"))
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        reprFp1EndDate: yup
          .date()
          .required(t("Το πεδίο είναι υποχρεωτικό"))
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        reprFp1SoloRepresentative: yup
          .number()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
        reprFp1JointlyRepresentative: yup
          .number()
          .required(t("Το πεδίο είναι υποχρεωτικό")),
      })
    ),
    newReprMembers: yup.array().of(
      yup.object().shape({
        fp1ReprName: yup.string().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1ReprSurname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1ReprFathersname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1ReprStartDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
        fp1ReprEndDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
        fp1ReprSoloRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp1ReprJointlyRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "ok",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2ReprName: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2ReprSurname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2ReprFathersname: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2ReprDoy: yup.object().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2ReprAdt: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
        fp2ReprOdos: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),

        fp2ReprArithm: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),

        fp2ReprTk: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
        }),

        fp2ReprPolh: yup.string().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),

        fp2ReprStartDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),

        fp2ReprEndDate: yup.date().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        }),
        fp2ReprSoloRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),

        fp2ReprJointlyRepresentative: yup.number().when(["ok"], {
          is: (ok: string) => ok === "no",
          then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
      })
    ),
    deletedReprMember: yup.array().of(
      yup.object().shape({
        deletedRp1StartDate: yup
          .date()
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
        deletedReprFp1EndDate: yup
          .date()
          .required(t("Το πεδίο είναι υποχρεωτικό"))
          .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      })
    ),
  });
};
